import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMfaDisable = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#BFC8CB",
		d: "M18.042 15.473 7.377 4.796 12 3.077l7 2.615V11.1q0 1.025-.22 2.102a11.6 11.6 0 0 1-.738 2.271m1.758 5.742-3.288-3.288a10 10 0 0 1-2.065 1.868A8.6 8.6 0 0 1 12 20.961q-3.148-.932-5.074-3.727T5 11.1V6.416L2.861 4.277l.708-.708 16.939 16.939z"
	})
});
export { SvgMfaDisable as ReactComponent };
